module.exports = __webpack_public_path__ + "static/media/backgroundImage.aeae64eb.jpg";